import moment from 'moment';
import { useEventNotifications } from './useEventNotifications';

// Notifications older than this (in minutes) will not be displayed on popup
const OLD_NOTIFICATION_THRESHOLD = 30;

export function useRecentNotifications(eventId) {
    return useEventNotifications(eventId, {
        filter: (notification) => moment().diff(notification.sent_on, 'minutes', true) < OLD_NOTIFICATION_THRESHOLD
    });
}
